import { useEffect, useRef } from 'react';
import { IBAN_MAX_LENGTH, IBAN_MIN_LENGTH } from '@constants';
import useValidateIBAN from './useValidateIBAN';

const useIbanBankSync = (
  iban: string,
  setValue: (name: 'bank', value: string, options?: { shouldValidate?: boolean }) => void,
  triggerIban: () => void,
) => {
  const validateIBAN = useValidateIBAN(iban);
  const isFirstBankSync = useRef(true);
  const setValueRef = useRef(setValue);
  setValueRef.current = setValue;
  const triggerIbanRef = useRef(triggerIban);
  triggerIbanRef.current = triggerIban;

  useEffect(() => {
    if (isFirstBankSync.current) {
      isFirstBankSync.current = false;
      return;
    }
    const normalized = iban?.replace(/\s/g, '') ?? '';
    const isValidLength = normalized.length >= IBAN_MIN_LENGTH && normalized.length <= IBAN_MAX_LENGTH;
    const bankName = isValidLength ? (validateIBAN.data?.data?.bankData?.name ?? '') : '';
    setValueRef.current('bank', bankName, { shouldValidate: bankName !== '' });
    if (isValidLength) {
      triggerIbanRef.current();
    }
  }, [iban, validateIBAN.data]);
};

export default useIbanBankSync;
